import SearchUserBaseForm from './SearchUserBaseForm';

export default SearchUserBaseForm;
